import {css} from "lit";
import {countIndicatorStyles} from "../common/CountIndicator.styles.js";
import {commonStyles} from "../common/styles/Common.js";
import {iconStyles} from "../common/styles/Icons.js";

export const outlineSectionStyles = [
	countIndicatorStyles,
	commonStyles,
	iconStyles,
	css`
	.outline-section {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: auto;
		padding: 30px 28px 0px 28px;
		text-align: left;
	}

	.outline-section.open .section-header .section-btn-toggle i {
		transform: rotate(0deg);
		transition-duration: 0.2s;
	}
	.outline-section.open .list {
		display: block;
	}
	.outline-section.open .list:not(:empty) {
		margin-top: 28px;
		padding-bottom: 15px;
	}

	.section-header {
		display: flex;
		align-items: center;
		white-space: nowrap;
	}

	.section-header .section-btn-toggle {
		width: 20px;
		height: 20px;
		margin-right: 5px;
		margin-bottom: 2px;
		font-size: var(--pn-font-size-base);
	}
	.section-header .section-btn-toggle i {
		transform: rotate(-90deg);
		transition-duration: 0.2s;
		margin: auto;
	}

	.section-header .section-label {
		display: flex;
		flex: 1;
		align-items: center;
		min-width: 0px;
		color: var(--pn-outline-topic-text-color-initial);
		font-weight: bold;
		font-size: calc(var(--pn-font-size-base) + 2px);
		line-height: 0;
		cursor: pointer;
	}
	.section-header .section-label .section-label-text {
		line-height: 20px;
	}
	.section-header .section-label input.section-label-text {
		flex: 1;
		min-width: 0;
		border: none;
		font-weight: 700;
		font-size: calc(var(--pn-font-size-base) + 2px);
		line-height: 0;
		border-bottom: 1px dashed var(--pn-outline-topic-label-border-bottom-color-edit);
		background-color: transparent;
	}
	.section-header .section-label input.section-label-text:focus {
		outline: none;
	}

	.section-header .section-label .edit-topic-name {
		flex-shrink: 0;
		margin-left: 10px;
		font-size: 16px;
		opacity: 0;
		transition: opacity .2s;
		text-decoration: none;
		cursor: pointer;
	}
	.section-header .section-label .edit-topic-name::part(button) {
		padding: 4px;
	}

	.section-header .section-label.editing .edit-topic-name {
		display: none;
	}

	.section-header .topic-btn-addnote {
		font-size: 20px;
		margin-left: 10px;
	}
	.section-header .topic-btn-addnote::part(button) {
		padding: 2px;
	}

	.section-header:focus-within .section-label .edit-topic-name,
	.section-header:hover .section-label .edit-topic-name {
		opacity: 0.55;
	}

	.section-header:focus-within .section-label .edit-topic-name:hover,
	.section-header:hover .section-label .edit-topic-name:hover,
	.section-header:focus-within .section-label .edit-topic-name:focus,
	.section-header:hover .section-label .edit-topic-name:focus {
		opacity: 0.8;
	}

	.outline-section .list {
		display: none;
		padding: 0;
	}

	.outline-section.mode-sidebar-drag .annotation-list-item {
		user-select: none;
		cursor: grab;
	}
	/* TODO override RTE styles */
	.outline-section.mode-sidebar-drag .annotation-list-item .ProseMirror, .dummy-editor {
		cursor: grab;
	}


	pn-annotation-freeform,
	pn-annotation-highlight,
	pn-annotation-image,
	pn-annotation-bookmark {
		display: block;
		margin-top: 10px;
	}

	pn-annotation-freeform:first-child,
	pn-annotation-highlight:first-child,
	pn-annotation-image:first-child,
	pn-annotation-bookmark:first-child {
		margin-top: 0px;
	}
`];
